import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/gossip';

export default function CategorySidebar() {
  const ranking = [...articles].sort((a, b) => Number(b.views.replace(/[^\d.]/g, '')) - Number(a.views.replace(/[^\d.]/g, ''))).slice(0, 5);

  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-base font-bold text-foreground-950">
          <i className="ri-bar-chart-2-line text-lg text-primary-500" aria-hidden="true"></i>
          阅读热度榜
        </h2>
        <ol className="mt-2 divide-y divide-background-200">
          {ranking.map((article, index) => (
            <li key={article.id} className="flex items-start gap-3 py-3">
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                  index === 0 ? 'bg-accent-500 text-foreground-950' : 'bg-background-200 text-foreground-700'
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0">
                <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors hover:text-primary-600">
                  <Link to={`/article/${article.slug}`}>{article.title}</Link>
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{article.views} 阅读</p>
              </div>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-base font-bold text-foreground-950">
          <i className="ri-layout-grid-line text-lg text-accent-600" aria-hidden="true"></i>
          全部栏目
        </h2>
        <ul className="mt-3 space-y-1">
          <li>
            <Link
              to="/category/all"
              className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-50 hover:text-primary-600"
            >
              全部图集
              <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
            </Link>
          </li>
          {categories.map((category) => (
            <li key={category.slug}>
              <Link
                to={`/category/${category.slug}`}
                className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-50 hover:text-primary-600"
              >
                {category.name}
                <i className={category.icon} aria-hidden="true"></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg bg-primary-950 p-5 text-background-100">
        <h2 className="font-heading text-base font-bold text-background-50">有想看的场次？</h2>
        <p className="mt-2 text-sm leading-relaxed text-background-200/80">
          告诉我们你关注的红毯与同框组合，编辑团队会优先整理相关图集。
        </p>
        <Link
          to="/contact"
          className="mt-4 flex h-10 cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md bg-accent-500 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
        >
          <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
          提交需求
        </Link>
      </div>
    </div>
  );
}